import React from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";

const UpdateAudio = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getUrlByOperation, error: urlError } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    id: id,
    File: null,
    name: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (id) {
      const fetchCatelogData = async () => {
        // const localStorageData = JSON.parse(localStorage.getItem("user"));
        // const token = localStorageData?.token;
        // const userid = localStorageData?.userid;

        const token = getCookie("token");
        const userid = getCookie("userid");
    
        if (!token || !userid) {
          console.error("Missing token or userId in localStorage");
          return;
        }
  
        try {
          const AudioSearch = getUrlByOperation("AudioSearch");
          const response = await axios.post(
            AudioSearch,
            { id: id },
            {
              headers: {
                "X-Authorization": token,
                UserId: userid,
                "Content-Type": "application/json-patch+json",
              },
            }
          );
  
  
          // Check if the data is in the expected format
          if (response.data && response.data.data && Array.isArray(response.data.data)) {
            setFormData({
              ...response.data.data[0],
              active: response.data.data[0].active === "Active", // Convert 'active' to boolean if necessary
            });
          } else {
            setMessage("No data found for the specified id.");
          }
        } catch (error) {
          console.error("Error fetching Catalogue data:", error);
          setMessage("Failed to fetch Catalogue data.");
        }
      };
  
      fetchCatelogData();
    }
  }, [id, getUrlByOperation]);
  

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "active" ? value === "Active" : value, // Convert active to boolean
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    // Create an object with only the fields that should be sent in the update request
    const updateData = {
      id: formData.id,
      active: formData.active, // Ensure it's a boolean value
      name: formData.name,
      File: formData.File,
    };

    try {
      const AudioUpadte = getUrlByOperation("AudioUpadte");
      await axios.post(
        AudioUpadte,
        updateData, // Send only the necessary fields
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );
      setMessage("Audio updated successfully!");

      // Set a delay before navigating
      setTimeout(() => {
        navigate("/audio");
      }, 3000);
    } catch (error) {
      setMessage("Failed to update audio.");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">
                        {id ? "Update" : "Add"} Audio
                      </h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="name"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>File</label>
                              <input
                                type="file"
                                className="form-control"
                                value={formData.File}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="File"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active ? "Active" : "Deactive"}
                                onChange={handleChange}
                              >
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            {id ? "Update" : "Add"}
                          </button>
                        </div>
                      </form>
                      {/* {message && <p>{message}</p>} */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {message === "Audio updated successfully!" ? (
      <SuccessMessage message={message} />
      ) : (
        ""
      )}

      {message === "Failed to update audio" ? (
        <FailedMessage message={message} />
      ) : (
        ""
      )}
    </>
  );
};

export default UpdateAudio;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

